'use client';

import a__default from "react";
import { LoadingSpinner } from "../../atoms/LoadingSpinner/LoadingSpinner.js";
import { Text } from "../../atoms/Text/Text.js";
import { classNames } from "../../utils/styles/classNames.js";
import { loadingStartMsg } from "./Select.data.js";
import { FakeOption } from "./Select.FakeOption.js";
import { loading } from "./Select.css.js";
function Loading({ isLoading }) {
  return isLoading && /* @__PURE__ */ a__default.createElement(FakeOption, null, /* @__PURE__ */ a__default.createElement("div", { className: classNames(loading) }, /* @__PURE__ */ a__default.createElement(LoadingSpinner, { size: "sm" }), /* @__PURE__ */ a__default.createElement(Text, { color: "onLight.text.tertiary" }, loadingStartMsg)));
}
export {
  Loading
};
